module.exports = __webpack_public_path__ + "media/images/mail-dadfe666773d857291f0bf743ea8d813.svg";